var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-lg btn-success",attrs:{"to":{ name: _vm.backLink },"id":_vm.id}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }